import { createAsyncTypes } from 'utils/ActionCreator'

export const PARTNER_SETTINGS_GET_ASYNC = createAsyncTypes('GET', 'Settings/Partner')
export const PARTNER_SETTINGS_UPDATE_ASYNC = createAsyncTypes('UPDATE', 'Settings/Partner')

export const PARTNER_FORM_CHANGE_FIELD = 'Settings/Partner/PARTNER_FORM_CHANGE_FIELD'
